import { supabase } from './supabaseClient';

const BASE = import.meta.env.VITE_ENGINE_API_URL || 'http://localhost:8787';

async function authHeaders() {
  const { data } = await supabase.auth.getSession();
  const token = data.session?.access_token;
  return token ? { Authorization: `Bearer ${token}` } : {};
}

async function req(method, path, body) {
  // Only set Content-Type when we actually send a JSON body — otherwise Fastify
  // rejects a body-less request (DELETE / POST with no payload) as 400
  // "body cannot be empty when content-type is set to application/json".
  const headers = { ...(await authHeaders()) };
  let payload;
  if (body !== undefined) {
    headers['Content-Type'] = 'application/json';
    payload = JSON.stringify(body);
  }
  const res = await fetch(BASE + path, { method, headers, body: payload });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || err.message || `${method} ${path} failed (${res.status})`);
  }
  const text = await res.text();
  return text ? JSON.parse(text) : null;
}

// Thin client -> engine command API. The engine is the single writer; reads
// come over Supabase Realtime, not from these calls.
export const api = {
  // wallet
  getWallet: () => req('GET', '/wallet'),
  createWallet: () => req('POST', '/wallet', { action: 'generate' }),
  importWallet: (secret) => req('POST', '/wallet', { action: 'import', secret }),
  revealWallet: () => req('POST', '/wallet/reveal'),
  deleteWallet: () => req('DELETE', '/wallet'),
  withdraw: (dest, amountSol) => req('POST', '/wallet/withdraw', { dest, amountSol }),
  getTokens: () => req('GET', '/wallet/tokens'),
  swapQuote: (inputMint, outputMint, amountRaw) => req('POST', '/wallet/quote', { inputMint, outputMint, amountRaw }),
  swap: (inputMint, outputMint, amountRaw) => req('POST', '/wallet/swap', { inputMint, outputMint, amountRaw }),
  // settings
  getSettings: () => req('GET', '/settings'),
  saveSettings: (patch) => req('PUT', '/settings', patch),
  getProviderHealth: () => req('GET', '/health/providers'),
  getSolPrice: () => req('GET', '/sol-price'),
  // orders / positions
  placeOrder: (order) => req('POST', '/orders', order),
  sellPosition: (id, percentage = 100, reason = 'Manual') => req('POST', `/positions/${id}/sell`, { percentage, reason }),
  updatePosition: (id, patch) => req('PATCH', `/positions/${id}`, patch),
  deletePosition: (id) => req('DELETE', `/positions/${id}`),
  forceClose: (id) => req('POST', `/positions/${id}/force-close`),
  clearClosed: () => req('POST', '/positions/clear-closed'),
  // watchlist
  addWatch: (address, strategy, timeframe) => req('POST', '/watchlist', { address, strategy: strategy || null, timeframe: timeframe || null }),
  updateWatch: (address, strategy, timeframe) => req('PATCH', `/watchlist/${encodeURIComponent(address)}`, { strategy: strategy || null, timeframe: timeframe || null }),
  removeWatch: (address) => req('DELETE', `/watchlist/${encodeURIComponent(address)}`)
};
